import { USER, USER_LOGIN, USER_INTEREST } from "../actions";
import BrowserData from "@core/helper/browserData";
import { cacheData, clearCache } from "@core/utils/localStorageManager";
import user from "@api/user";

export const userInitState = {
  authorized: false,
  isLoading: false,
  user: {
    firstName: "",
    lastName: "",
    mobile: "",
    setting: {
      isUsing2FA: null,
      whitelistEnable: null
    }
  },
  token: null
};

export const userReducer = (state = userInitState, action) => {
  switch (action.type) {
    case "SET_WHITELIST":
      return {
        ...state,
        user: {
          ...state.user,
          setting: {
            ...state.user.setting,
            whitelistEnable: action.payload.whitelistEnable
          }
        }
      };

    case "SET_TFA":
      return {
        ...state,
        user: {
          ...state.user,
          setting: {
            ...state.user.setting,
            isUsing2FA: action.payload.isUsing2FA
          }
        }
      };

    case USER.LOGIN.SUCCESS:
      cacheData("access_token", action.payload.token);
      return {
        ...state,
        authorized: true,
        token: action.payload.token,
        isLoading: false,
      };

    case USER.LOGIN.REQUEST:
    case USER.REQUEST:
      return { ...state, isLoading: true };

    case USER.FETCH.SUCCESS:
      BrowserData.set("user", action.payload.user);
      return {
        ...state,
        user: action.payload.user,
        authorized: true,
        auth: true,
        isLoading: false,
      };

    case USER.SESSION_EXPIRED:
      if (typeof window !== "undefined") {
        window.localStorage.removeItem("access_token");
      }
      return { ...userInitState, isLoading: false };

    case USER.LOGOUT.REQUEST:
      clearCache();
      return userInitState;

    case USER.LOGIN.ERROR:
    case USER.FETCH.ERROR:
      return { ...state, isLoading: false, auth: false, authorized: false };

    default:
      return state;
  }
};
